import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-171d0836"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "axero-widget axero-search-widget tl-widget-leaderboard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "axero-widget-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Streak Leaderboard")
], -1 /* HOISTED */))
const _hoisted_3 = { class: "axero-widget-content" }
const _hoisted_4 = { class: "tl-streaks" }
const _hoisted_5 = {
  key: 0,
  class: "divider"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-left" }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider-right" }, null, -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "tl-streaks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StreakComponent = _resolveComponent("StreakComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topStreaks, (streak) => {
          return (_openBlock(), _createElementBlock("li", {
            key: streak.User.UserID
          }, [
            _createVNode(_component_StreakComponent, { streak: streak }, null, 8 /* PROPS */, ["streak"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      (_ctx.relativeStreaks.length > 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
        : _createCommentVNode("v-if", true),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relativeStreaks, (streak) => {
          return (_openBlock(), _createElementBlock("li", {
            key: streak.User.UserID
          }, [
            _createVNode(_component_StreakComponent, { streak: streak }, null, 8 /* PROPS */, ["streak"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}